import { render, staticRenderFns } from "./Tipo_Equipo.vue?vue&type=template&id=2bcdec2a&"
import script from "./Tipo_Equipo.vue?vue&type=script&lang=js&"
export * from "./Tipo_Equipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports